"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomSwitch = CustomSwitch;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const formik_1 = require("formik");
const __1 = require("../");
const Label_1 = require("./Label");
function CustomSwitch({ label, name, disabled, options, required, onClick, onChangeHandler, }) {
    const [props, meta, helpers] = (0, formik_1.useField)({
        name,
        required,
        disabled,
    });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Label_1.MultiLineLabel, { label: label, name: name, disabled: disabled, required: false }),
        react_1.default.createElement(__1.MultiSwitch, { options: options, callback: (option) => {
                onChangeHandler && onChangeHandler(option);
                helpers.setValue(option);
                onClick && onClick(option);
            }, selected: props.value || options[0].value, disabled: disabled, minWidth: "15ex", label: label }),
        meta.error && meta.touched && react_1.default.createElement(__1.FieldError, null, meta.error)));
}
//# sourceMappingURL=CustomSwitch.js.map